/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AdDesignUpdateDefaultsPathParams,
	AdDesignUpdateDefaultsRequest,
	AdDesignUpdateDefaultsResponse,
} from '../types/AdDesignUpdateDefaults'

/**
 * PUT /organisations/:organisation/default-designs
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::updateDefaults
 */
export async function adDesignUpdateDefaults(
	organisation: AdDesignUpdateDefaultsPathParams['organisation'],
	data: AdDesignUpdateDefaultsRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignUpdateDefaultsResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/default-designs`, data, config)
}
